var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[(!_vm.isDemoUser)?_c('p',[_vm._v(_vm._s(_vm.$t('footer.copyright', { year: _vm.currentYear })))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }